import { MemorySticksStatus } from "../../shared-gen/Device/Status/MemorySticksStatus";
import { MemoryStickLicenseState } from "../../shared-gen/Device/Status/MemoryStickLicenseState";

export class MemorySticksStatusFun {

	static createNew(): MemorySticksStatus {
		return {
			LicenseState: MemoryStickLicenseState.None,
			Sticks: []
		};
	}

}
